import classNames from 'classnames'
import React from 'react'
interface LabelProps {
  typography?: string
  lineBreak?: boolean
}
/* Intended to be used for unifying label looks

Typography parameter allows us to customize typography without causing conflicts.
We do not need tailwind merge utility and we do not get potential explosion of parameters
to customize the element so we have middle ground solution to customize set of typography settings.
*/

export const FormLabel = ({
  children,
  className = '',
  lineBreak = true,
  typography = 'leading-5 text-xs font-semibold text-secondaryFontColor',
  ...props
}: LabelProps & React.LabelHTMLAttributes<HTMLLabelElement>) => {
  return (
    <label
      {...props}
      className={classNames(
        'block min-h-5',
        typography,
        lineBreak ? `after:content-['\\A'] after:whitespace-pre` : '',
        className
      )}
    >
      {children}
    </label>
  )
}
